import { LegalLayout, LegalSection } from "@/components/nuit/LegalLayout";

export default function CGV() {
  return (
    <LegalLayout
      title="Conditions Générales de Vente"
      updated="Juin 2026"
    >
      <LegalSection n="01" title="Objet et champ d’application">
        <p>
          Les présentes Conditions Générales de Vente (CGV) régissent la vente du
          programme digital « NUIT CALME » et des services associés, proposés par{" "}
          <strong className="text-white/80">MBSYNAPSE</strong> sur le site
          nuitcalme.eu.
        </p>
        <p>
          Toute commande implique l’acceptation pleine et entière des présentes
          CGV par le client, qui déclare en avoir pris connaissance avant de
          finaliser son achat. MBSYNAPSE se réserve le droit de modifier les CGV à
          tout moment&nbsp;; les CGV applicables sont celles en vigueur à la date de
          la commande.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Produits et services">
        <p>
          NUIT CALME est un programme progressif de 21 nuits d’hygiène du sommeil et
          de relaxation, proposé sous forme de contenus numériques&nbsp;: guide PDF,
          journal du sommeil, exercices, relaxations audio guidées, ambiances
          sonores et, selon la formule, accès à une application web.
        </p>
        <p>
          Il s’agit d’un programme de bien-être. Il ne constitue pas un dispositif
          médical et ne remplace pas l’avis d’un professionnel de santé.
        </p>
      </LegalSection>

      <LegalSection n="03" title="Prix">
        <p>
          Les prix sont indiqués en euros, toutes taxes comprises (TTC). Trois
          formules sont proposées en paiement unique&nbsp;:
        </p>
        <ul className="ml-4 list-disc space-y-1.5 marker:text-[#c9a84c]">
          <li>Essentiel — 19,90&nbsp;€</li>
          <li>Complet — 39,90&nbsp;€</li>
          <li>Premium — 69,90&nbsp;€</li>
        </ul>
        <p>
          Un abonnement optionnel de <strong className="text-white/80">4,90&nbsp;€/mois</strong>{" "}
          (nouvelles histoires, méditations et ambiances) peut être souscrit
          séparément. Il est sans engagement et résiliable à tout moment&nbsp;; la
          résiliation prend effet à la fin de la période mensuelle en cours.
        </p>
        <p>
          MBSYNAPSE se réserve le droit de modifier ses prix à tout moment, étant
          entendu que le prix appliqué est celui en vigueur au moment de la
          commande.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Modalités de paiement">
        <p>
          Le paiement s’effectue en ligne, de manière sécurisée, via notre
          prestataire de paiement <strong className="text-white/80">Stripe</strong>.
          Les données bancaires sont traitées directement par Stripe et ne sont
          jamais conservées par MBSYNAPSE.
        </p>
        <p>
          La commande est validée après confirmation effective du paiement. En cas
          de refus de paiement, la commande est automatiquement annulée.
        </p>
      </LegalSection>

      <LegalSection n="05" title="Livraison et accès">
        <p>
          Les produits étant entièrement numériques, l’accès au programme est
          fourni <strong className="text-white/80">immédiatement</strong> après la
          confirmation du paiement, par e-mail et/ou via un accès en ligne, à
          l’adresse renseignée lors de la commande.
        </p>
        <p>
          Il appartient au client de fournir une adresse e-mail valide et de
          vérifier ses courriers indésirables. En cas de non-réception, le client
          peut contacter{" "}
          <a
            href="mailto:contact@nuitcalme.eu"
            className="text-[#e8c97a] hover:underline"
          >
            contact@nuitcalme.eu
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection n="06" title="Droit de rétractation">
        <p>
          Conformément aux articles L.221-18 et suivants du Code de la consommation,
          le client dispose en principe d’un délai de{" "}
          <strong className="text-white/80">14 jours</strong> pour exercer son droit
          de rétractation à compter de la conclusion du contrat.
        </p>
        <p>
          Toutefois, conformément à l’article L.221-28 13° du Code de la
          consommation, ce droit de rétractation ne peut être exercé pour la
          fourniture d’un contenu numérique non fourni sur un support matériel dont
          l’exécution a commencé après accord préalable exprès du consommateur et
          renoncement exprès à son droit de rétractation. En validant sa commande
          et en accédant au contenu, le client demande expressément l’exécution
          immédiate du service et reconnaît perdre son droit de rétractation dès le
          téléchargement ou le début de l’accès au contenu numérique.
        </p>
        <p>
          À titre commercial, MBSYNAPSE propose une garantie « satisfait ou
          remboursé » de 14 jours&nbsp;: en cas d’insatisfaction, contactez-nous à{" "}
          <a
            href="mailto:contact@nuitcalme.eu"
            className="text-[#e8c97a] hover:underline"
          >
            contact@nuitcalme.eu
          </a>{" "}
          pour obtenir un remboursement selon les conditions communiquées.
        </p>
      </LegalSection>

      <LegalSection n="07" title="Garanties et responsabilité">
        <p>
          Les contenus sont fournis « en l’état » à des fins de bien-être. Le client
          reste seul responsable de l’usage qu’il en fait. MBSYNAPSE ne saurait être
          tenue responsable des résultats individuels, qui peuvent varier d’une
          personne à l’autre.
        </p>
        <p>
          En cas de troubles du sommeil persistants ou de tout problème de santé,
          le client est invité à consulter un professionnel de santé. Le client
          bénéficie par ailleurs des garanties légales de conformité prévues par le
          droit applicable aux contenus et services numériques.
        </p>
      </LegalSection>

      <LegalSection n="08" title="Données personnelles">
        <p>
          Les données personnelles collectées dans le cadre de la commande sont
          traitées conformément au RGPD et à notre politique décrite dans les{" "}
          <strong className="text-white/80">Mentions légales</strong>. Le client
          dispose notamment d’un droit d’accès, de rectification et de suppression
          de ses données en écrivant à contact@nuitcalme.eu.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Droit applicable et juridiction compétente">
        <p>
          Les présentes CGV sont soumises au droit français. En cas de litige, une
          solution amiable sera recherchée en priorité. À défaut, le client
          consommateur peut recourir gratuitement à un médiateur de la consommation.
        </p>
        <p>
          À défaut de résolution amiable, les tribunaux français seront seuls
          compétents. Pour les clients consommateurs résidant dans l’Union
          européenne, les dispositions impératives protectrices de leur pays de
          résidence demeurent applicables.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Contact">
        <p>
          Pour toute question relative aux présentes CGV ou à votre commande&nbsp;:{" "}
          <a
            href="mailto:contact@nuitcalme.eu"
            className="text-[#e8c97a] hover:underline"
          >
            contact@nuitcalme.eu
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
